<template>
    <div class="header-warpper flex align-center">
        <div class="logo-box flex align-center justify-around">
            <img src="../assets/img/logo.png" alt="">
        </div>
        <div class="flex-sub flex align-center justify-end user-info">
            <el-button type="text" class="flex align-center font-size" @click="signOut"><i
                class="iconfont icon-tuichu font-size-lg"></i>退出
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "header-modular",
    data() {
        return {}
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
    },
    methods: {
        signOut() {
            this.$confirm('您确定要退出吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$store.state.user = null
                window.localStorage.clear()
                this.$router.replace('/login')
            })

        }
    },
}
</script>

<style scoped lang="scss">
.header-warpper {
    width: 100%;
    height: 80px;
    background: #fff;

    .logo-box {
        padding-left: 30px;
    }

    .user-info {
        padding: 0 30px;
        height: 75px;
    }

}
</style>